import { getDeviceInfo, getBannerPlayerRegCookies, customSetCookie } from '~/utils/deviceInfo'
import { getFingerprint } from '~/utils/fingerprint'
// State
export const state = () => ({
  loading: false,
  rejectAllApiRequests: false,
  registerFormEvent: {}
})
// Actions
export const actions = {
  async getReferralInfo({ _ }, playerId) {
    try {
      const referralInfo = await this.$axios.get(`/players/referer-info/${playerId}`, {
        headers: {
          'Cache-Control': 'no-cache'
        },
        retry: 5,
        retryDelay: 500
      })
      return referralInfo.data
    } catch (error) {
      return {
        exists: false
      }
    }
  },
  async registration({ commit, dispatch, rootState, rootGetters, state }, data) {
    const referralId = data.referralId
    delete data.referralId

    const registrationOption = data.reg_flow
    const recaptchaToken = data.recaptchaToken
    const isRememberMe = data.rememberMe
    const bankOptionSelection = data.bankOptionSelection

    // Default Form for registration
    const form = {
      password: data.password,
      phone: data.phone,
      currency: data.currency,
      language: rootGetters['base-settings/getWhiteLabelLocale'],
      country_code: data.country_code,
      player_id: data.player_id
    }

    // Check Registration Option to Send the Required Form Body
    if (registrationOption === 1) {
      form.bank_id = data.bank_id
      form.bank_name = data.bank_name

      // If bank option is Bank List then delete the Manually Bank Name
      if (bankOptionSelection === 1) delete form.bank_name
      else delete form.bank_id
      form.bank_account_number = data.bank_account_number
      form.bank_currency = data.bank_currency
      form.account_holder_name = data.account_holder_name
      form.bank_branch = data.bank_branch
    } else if (registrationOption === 2 || registrationOption === 3) {
      form.account_holder_name = data.account_holder_name
    }

    const defaultWebsiteDataFromDefaultAPI = rootState.settings.defaultWebsiteData
    const xBannerId = this.$cookie.get('x-direct-banner-id') // It was set by /visit or /default api
    const xBannerUrl = this.$cookie.get('x-banner-url') // It was set by banner redirection link
    const xPlayerType = this.$cookie.get('x-player-type') // It was set by /visit or /default api
    const previousUrl = this.$cookie.get('x-referral-url') // It was set by JS document.referral
    const xClickId = this.$cookie.get('x-click-id')

    // Header Request Form
    const userPlatform = rootState.app.isApp.detected
      ? 'app'
      : rootState.themes.settings.isMobile
      ? 'mobile'
      : 'desktop'
    const headers = {
      'x-platform': userPlatform
    }
    if (defaultWebsiteDataFromDefaultAPI.recaptcha_status) headers['auth-key'] = recaptchaToken
    if (defaultWebsiteDataFromDefaultAPI['x-domain-name'])
      headers['X-DOMAIN-NAME'] = defaultWebsiteDataFromDefaultAPI['x-domain-name']
    if (xPlayerType) headers['X-PLAYER-TYPE'] = xPlayerType
    if (previousUrl) headers['X-AFFILIATE-URL'] = previousUrl
    if (xBannerId) headers['X-DIRECT-BANNER-ID'] = xBannerId
    if (xClickId) headers['x-click-id'] = xClickId

    if (sessionStorage.getItem('fbclid') && localStorage.getItem('pixel_id')) {
      headers['x-banner-pixel-id'] = localStorage.getItem('pixel_id')
      headers['X-DIRECT-BANNER-ID'] = localStorage.getItem('banner_id')
    }

    // Checking referral condition [invite-and-earn link]
    if (referralId) {
      const referralInfo = await dispatch('getReferralInfo', referralId)
      // Check if the player the same origin
      if (referralInfo.exists) {
        headers['X-REFERRAL-ID'] = referralId
        headers['X-REFERRAL-CURRENCY'] = referralInfo.currency
      }
    }

    // x-banner-url header should not be present if it's invite-and-earn link
    if (xBannerUrl && !headers['X-REFERRAL-ID']) headers['X-BANNER-URL'] = xBannerUrl

    const banner = getDeviceInfo()
    headers['x-device-name'] = banner.deviceName
    headers['x-login-device'] = banner.deviceType
    const xDevicePlayerId = getBannerPlayerRegCookies()
    if (xDevicePlayerId && xDevicePlayerId?.length > 0) {
      headers['x-device-player-id'] = JSON.stringify(xDevicePlayerId)
    }
    if (process.client) {
      headers['x-device-fingerprint'] = getFingerprint()
      headers['x-register-url'] = window.location.href
    }
    const redirectPageAfterRegistration = rootState.themes.settings.isMobile ? '/games' : '/'
    const res = await this.$axios
      .post(
        `/registration/option/${registrationOption}`,
        { ...form, event_data: { ...state.registerFormEvent } },
        {
          headers
        }
      )
      .then(async response => {
        await this.$cookie.set('token', response.headers.token, {
          path: '/',
          maxAge: 60 * 60 * 3 - 60
        })
        await this.commit('player/setPlayer', response.data)

        const playerData = {
          player_id: response.data.player_id,
          phone: response.data.phone,
          currency: response.data.currency,
          country_code: response?.data?.country_code,
          has_crypto_wallet: response.data.has_crypto_wallet,
          has_bank_account: response.data.has_bank_account,
          player_ref_status: response.data.player_ref_status,
          is_crypto_payment_enabled: response.data.is_crypto_payment_enabled,
          is_third_party_payment_enabled: response.data.is_third_party_payment_enabled,
          registration_type: response.data.registration_type,
          created_at: response.data.created_at,
          nickname: response.data.nickname,
          player_ref_rel_code: response.data.player_ref_rel_code,
          note: response.data.note,
          vip_tier_id: response.data.vip_tier_id,
          native_name: response.data.native_name,
          vip_tier_signature: response.data.vip_tier_signature,
          bonus_amount: response.data.bonus_amount
        }
        await this.$cookie.set('player', playerData)
        this.$cookie.set('currency', response.data.currency)
        this.$cookie.set('country_code', response?.data?.country_code)
        customSetCookie(`banner-player-reg-${playerData.player_id}`, playerData.player_id, 10)
        await this.dispatch('settings/toggleIsLogin', true, {
          root: true
        })
        await this.dispatch('player/totalBalance', true, { root: true })

        // To set and remove rememberMe data
        setRegisterRememberMe(this.$cookie, {
          playerId: response.data.player_id,
          phone: response.data.phone,
          rememberMe: isRememberMe
        })

        this.$toast.success(this.getters['themes/language-string/tl']('registerSuccessful'))
        this.$cookie.remove('referral')
        this.$cookie.remove('previous_url')
        // this.$cookie.remove('x-direct-banner-id')
        // this.$cookie.remove('x-banner-url')
        // this.$cookie.remove('x-player-type')

        dispatch('themes/player-bank/getBankPlayerAccount', true, {
          root: true
        })
        // To get the invite and earn domain link
        dispatch('player/getPlayerInviteAndEarnDomain', true, {
          root: true
        })
        return true
      })
      .catch(e => {
        // If the website is under maintenance during registration
        if (e?.response?.data?.website_maintenance) {
          this.$router.go('/')
        }
        return false
      })
      .finally(() => {
        commit('loading', false)
      })
    return { redirect: redirectPageAfterRegistration, res }
  },
  // login
  async login({ commit, dispatch, rootState }, form) {
    commit('loading', true)
    const defaultWebsiteDataFromDefaultAPI = rootState.settings.defaultWebsiteData

    const recaptchaToken = form.recaptchaToken
    delete form.recaptchaToken
    const rememberMe = form.rememberMe
    delete form.rememberMe

    const userPlatform = rootState.app.isApp.detected
      ? 'app'
      : rootState.themes.settings.isMobile
      ? 'mobile'
      : 'desktop'
    const headers = {
      'x-platform': userPlatform
    }

    const banner = getDeviceInfo()
    headers['x-device-name'] = banner.deviceName
    headers['x-login-device'] = banner.deviceType
    const xDevicePlayerId = getBannerPlayerRegCookies()
    if (xDevicePlayerId && xDevicePlayerId?.length > 0) {
      headers['x-device-player-id'] = JSON.stringify(xDevicePlayerId)
    }
    // headers['x-device-fingerprint'] = form.reg_fingerprint
    if (process.client) {
      headers['x-device-fingerprint'] = getFingerprint()
    }
    // auth-key will be always required for lao client
    // For international: check by /default api
    if (
      defaultWebsiteDataFromDefaultAPI.recaptcha_status ||
      !rootState.themes.settings.isInternational
    )
      headers['auth-key'] = recaptchaToken
    await this.$axios
      .post(`/players/login`, form, {
        headers
      })
      .then(response => {
        if (response.status === 200) {
          this.$cookie.set('token', response.headers.token, {
            path: '/',
            maxAge: 60 * 60 * 3 - 60
          })
          dispatch('base-settings/updateLocaleAndSetCookie', response.data.language, { root: true })

          const playerData = {
            player_id: response.data.player_id,
            phone: response.data.phone,
            currency: response.data.currency,
            country_code: response?.data?.country_code,
            has_crypto_wallet: response.data.has_crypto_wallet,
            has_bank_account: response.data.has_bank_account,
            player_ref_status: response.data.player_ref_status,
            is_crypto_payment_enabled: response.data.is_crypto_payment_enabled,
            is_third_party_payment_enabled: response.data.is_third_party_payment_enabled,
            registration_type: response.data.registration_type,
            created_at: response.data.created_at,
            nickname: response.data.nickname,
            player_ref_rel_code: response.data.player_ref_rel_code,
            note: response.data.note,
            vip_tier_id: response.data.vip_tier_id,
            native_name: response.data.native_name,
            vip_tier_signature: response.data.vip_tier_signature,
            bonus_amount: response.data.bonus_amount
          }
          this.$cookie.set('player', playerData)
          this.$cookie.set('currency', response.data.currency)
          customSetCookie(`banner-player-reg-${playerData.player_id}`, playerData.player_id, 10)
          this.$toast.success(this.getters['themes/language-string/tl']('loginSuccessful'))

          if (form.player_id) {
            if (rememberMe)
              this.$cookie.set('un', form.player_id, {
                path: '/',
                maxAge: 60 * 60 * 24 * 30 - 60
              })
            else this.$cookie.remove('un')
          } else if (form.phone) {
            if (rememberMe)
              this.$cookie.set('pn', form.phone, {
                path: '/',
                maxAge: 60 * 60 * 24 * 30 - 60
              })
            else this.$cookie.remove('pn')
          }

          this.$router.go('/')
        }
      })
      .catch(e => {
        // If the website is under maintenance during login
        if (e?.response?.data?.website_maintenance) {
          this.$router.go('/')
        }
        commit('loading', false)
      })
  },
  async logout({ commit, dispatch }) {
    try {
      if (this.$cookie.get('token')) {
        await this.$axios.put('/players/logout').finally(() => {
          this.$cookie.remove('token')
          dispatch('settings/toggleIsLogin', false, { root: true })
          // this.$toast.success(
          //     this.getters['themes/language-string/tl'](
          //         'logoutSuccessful'
          //     )
          // )
          this.$cookie.remove('player')

          this.$router.push('/')
          // Since the $router is not working inside this async, need to use JS build-in window
          window.location.reload()
        })
      }
    } catch (error) {}
  }
}
// Mutations
export const mutations = {
  loading: (state, v) => {
    state.loading = v
  },
  setRejectAllApiRequests: (state, v) => {
    state.rejectAllApiRequests = v
  },
  setRegisterFormEvent: (state, v) => {
    state.registerFormEvent = v
  }
}

function setRegisterRememberMe(cookie, { playerId, phone, rememberMe }) {
  if (rememberMe) {
    cookie.set('un', playerId, {
      path: '/',
      maxAge: 60 * 60 * 24 * 30 - 60
    })
    cookie.set('pn', phone, {
      path: '/',
      maxAge: 60 * 60 * 24 * 30 - 60
    })
  } else {
    cookie.remove('un')
    cookie.remove('pn')
  }
}
